// extracted by mini-css-extract-plugin
module.exports = {"work-status":"work-panel_work-status__1mkM9"};